import { createSelector } from 'reselect'
import { getUserLoggedIn } from 'react-redux/selectors/user'
import { getApp } from 'react-redux/selectors/app'
import { getBrand } from 'react-redux/selectors/brand'
import { PUBLIC_VIEWS, LOGIN } from './view'

export default createSelector(
  [ getBrand, getUserLoggedIn, getApp],
  (brand, loggedIn, app) => {
    let view
    if (loggedIn || PUBLIC_VIEWS.indexOf(app.view)>-1) {
      view = app.view
    } else {
      view = LOGIN
    }
    return Object.assign(
      {},
      app,
      {
        brand,
        view,
        loggedIn
      }
    )
  }
)



// WEBPACK FOOTER //
// ./src/app/component/app/selector.js